import Cookies from 'js-cookie';
import { getBaseUrl } from '../utils/apiHelper';
import authService from './authService';

const API_URL = `${getBaseUrl()}/api/clients`;

const clientService = {
    getAllClients: async () => {
        try {
            console.log("📡 Fetching all clients...");
            const userId = Cookies.get("userId"); // Retrieve user ID from cookies

            if (!userId) {
                throw new Error("User ID is required.");
            }

            const response = await authService.authenticatedFetch(`${API_URL}?userId=${userId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch clients.");
            }

            console.log("✅ Clients fetched successfully:", data.clients);
            return data.clients;
        } catch (error) {
            console.error("❌ Error fetching clients:", error);
            throw error;
        }
    },

    getClientById: async (clientId) => {
        try {
            const token = Cookies.get("token");
            const endpoint = `${API_URL}/${clientId}`;
            console.log(`Fetching client with endpoint: ${endpoint}`);
            
            const res = await fetch(endpoint, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            const data = await res.json();
            if (!res.ok) {
                console.error(`❌ Failed to fetch client: ${data.message}`);
                throw new Error(data.message || "Failed to fetch client");
            }

            console.log("✅ Client fetched successfully:", data.client);
            return data.client;
        } catch (error) {
            console.error("❌ Error fetching client:", error.message);
            throw error;
        }
    },

    updateClient: async (clientId, updatedData) => {
        try {
            const token = Cookies.get("token");
            const endpoint = `${API_URL}/${clientId}`;
            console.log(`Updating client with endpoint: ${endpoint}`);

            const res = await fetch(endpoint, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(updatedData)
            });

            const data = await res.json();
            if (!res.ok) {
                console.error(`❌ Failed to update client: ${data.message}`);
                throw new Error(data.message || "Failed to update client");
            }

            console.log("✅ Client updated successfully:", data.client);
            return data.client;
        } catch (error) {
            console.error("❌ Error updating client:", error.message);
            throw error;
        }
    },

    getClientsForComboBox: async () => {
        try {
            const token = Cookies.get("token");
            const res = await fetch(`${API_URL}/combo-box`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            const data = await res.json();
            if (!res.ok) {
                console.error(`❌ Failed to fetch clients for combo box: ${data.message}`);
                throw new Error(data.message || "Failed to fetch clients for combo box");
            }

            console.log("✅ Clients for combo box fetched successfully:", data.clients);
            return data.clients;
        } catch (error) {
            console.error("❌ Error fetching clients for combo box:", error.message);
            throw error;
        }
    },    createClient: async (name, forwardEmail, appfolioUrl) => {
        try {
            const token = Cookies.get("token");
            const res = await fetch(API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ name, forwardEmail, appfolioUrl }),
            });

            const data = await res.json();
            if (!res.ok) {
                console.error(`❌ Failed to create client: ${data.message}`);
                throw new Error(data.message || "Failed to create client");
            }

            console.log("✅ Client created successfully:", data.client);
            return data.client;
        } catch (error) {
            console.error("❌ Error creating client:", error.message);
            throw error;
        }
    },

    deleteClient: async (clientId) => {
        try {
            const token = Cookies.get("token");
            const endpoint = `${API_URL}/${clientId}`;
            console.log("[clientService] deleteClient called with:", clientId);
            console.log("[clientService] DELETE endpoint:", endpoint);
            console.log("[clientService] Token:", token);
            const res = await fetch(endpoint, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });
            console.log("[clientService] Response status:", res.status);
            const contentType = res.headers.get("content-type");
            console.log("[clientService] Response content-type:", contentType);
            let data = {};
            if (contentType && contentType.includes("application/json")) {
                data = await res.json();
                console.log("[clientService] Response JSON:", data);
            } else {
                const text = await res.text();
                console.log("[clientService] Response text:", text);
                throw new Error(`Unexpected response: ${text}`);
            }
            if (!res.ok) {
                console.error(`[clientService] ❌ Failed to delete client: ${data.message}`);
                throw new Error(data.message || "Failed to delete client");
            }
            console.log("[clientService] ✅ Client deleted successfully.");
            return true;
        } catch (error) {
            console.error("[clientService] ❌ Error deleting client:", error.message);
            throw error;
        }
    },
};

export default clientService;
